import { useState, useEffect } from 'react';
import { fetchHHCurrencies } from '../services/hhDictionariesService';
import { CURRENCY_OPTIONS } from './useResponsesFilters';

export interface CurrencySelectOption {
  value: string;
  label: string;
}

// Только нужные валюты в фиксированном порядке: рубли, доллары, евро, белорусские рубли, тенге
const ALLOWED_CURRENCIES = ['RUR', 'USD', 'EUR', 'BYR', 'KZT'];

const CURRENCY_SYMBOLS: Record<string, string> = {
  RUR: '₽',
  USD: '$',
  EUR: '€',
  BYR: 'Br',
  KZT: '₸',
};

function toCurrencySelectOption(id: string, abbr: string): CurrencySelectOption {
  return { value: id, label: CURRENCY_SYMBOLS[id] || abbr || id };
}

/**
 * Загружает список валют с HH.ru. До загрузки возвращает статический fallback CURRENCY_OPTIONS.
 * Все компоненты с селектом валюты должны использовать этот хук вместо константы CURRENCY_OPTIONS.
 */
export function useCurrencies(): CurrencySelectOption[] {
  const [currencies, setCurrencies] = useState<CurrencySelectOption[]>(CURRENCY_OPTIONS);

  useEffect(() => {
    fetchHHCurrencies()
      .then((items) => {
        const filtered = items
          .filter((c) => ALLOWED_CURRENCIES.includes(c.id))
          .sort((a, b) => ALLOWED_CURRENCIES.indexOf(a.id) - ALLOWED_CURRENCIES.indexOf(b.id));
        if (filtered.length > 0) {
          setCurrencies(filtered.map((c) => toCurrencySelectOption(c.id, c.abbr)));
        }
      })
      .catch(() => {
        // при ошибке сети остаётся fallback CURRENCY_OPTIONS
      });
  }, []);

  return currencies;
}
